<div class="d-flex flex-column align-items-center pb-6 pt-8">
  <img src="assets/images/planet-bw.svg" alt="planet-bw" width="86" height="86" />

  <p class="text-align-center mt-4">Something went wrong,<br />try reloading the page</p>

  <ds-button (click)="refreshPage()" label="Refresh" class="mt-10 pt-1" data-id="refresh" />
</div>
